import { Container, InfoDrawer, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { ContactSupport } from '../../../ContactSupport'
import { AliceCardFragment } from '@alice-financial/alice-sdk'
import { StripeElementPlaceholder } from '../stripe/StripeElementPlaceholder'
import { useWalletButton } from '../stripe/useWalletButton'
import { useStripeConnectedAccountId } from '../stripe/useStripeConnectedAccountId'
import { WalletButtonLoadingState } from '../stripe/WalletButtonLoadingState'
import { useSupportsApplePay } from '../../../../../utils/useSupportsApplePay'

const ANCHOR_NAME = 'digital-wallet-info'

type InfoContentProps = {
  stripeAccount: string
  card: AliceCardFragment
}

const InfoContent = ({ card, stripeAccount }: InfoContentProps) => {
  const supportsApplePay = useSupportsApplePay()
  const { mountButton, isLoading } = useWalletButton({ card, stripeAccount })

  return (
    <>
      <Container>
        {supportsApplePay && (
          <>
            <Typography variant="h3" gutterBottom>
              <FormattedMessage
                id="cards.alice.digital_wallet.add_your_alice_card_to_platform"
                values={{ platform: 'Apple Pay' }}
              />
            </Typography>
            {isLoading ? (
              <WalletButtonLoadingState />
            ) : (
              <StripeElementPlaceholder mount={mountButton} id="add-to-apple-pay" />
            )}
            <ul>
              <FormattedMessage id="cards.alice.digital_wallet.add_to_apple_pay_instructions_wpp" />
            </ul>
            <FormattedMessage id="cards.alice.digital_wallet.add_to_apple_pay_instructions_alternate" />
            <ul>
              <FormattedMessage id="cards.alice.digital_wallet.add_to_apple_pay_instructions" />
            </ul>
          </>
        )}
        <Typography variant="h3" mt={supportsApplePay ? 2 : 0}>
          <FormattedMessage
            id="cards.alice.digital_wallet.add_your_alice_card_to_platform"
            values={{ platform: 'Google Pay' }}
          />
        </Typography>
        <ul>
          <FormattedMessage id="cards.alice.digital_wallet.add_to_google_pay_instructions" />
        </ul>
      </Container>
      <ContactSupport />
    </>
  )
}

type DigitalWalletInfoProps = {
  children?: React.ReactNode
  card: AliceCardFragment
}

export const DigitalWalletInfo = ({ card, children }: DigitalWalletInfoProps) => {
  const { stripeAccount } = useStripeConnectedAccountId()

  return (
    stripeAccount && (
      <InfoDrawer
        variant="button"
        title={
          <Typography variant="h2">
            <FormattedMessage id="cards.alice.digital_wallet.add_instant_card_to_digital_wallet" />
          </Typography>
        }
        anchorName={ANCHOR_NAME}
        infoContent={<InfoContent card={card} stripeAccount={stripeAccount} />}
      >
        {children}
      </InfoDrawer>
    )
  )
}
